"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.golf = void 0;
//
// Golf translation ids.
//
const golf = {
  accountSettings: 'PC:AppHeader:Header:AccountSettings',
  closeMenu: 'Shared:UtilityBar:Close',
  products: 'Shared:UtilityBar:AccountTray:MyProducts',
  account: 'PC:AppHeader:Header:Account',
  resources: 'PC:AppHeader:Header:Resources',
  renewals: 'PC:AppHeader:Header:MyRenewals',
  pro: 'PC:AppHeader:Header:ProDashboard',
  signin: 'Shared:UtilityBar:AccountTray:SignIn',
  signout: 'Shared:AccountTray:SignOut',
  shopperid: 'PC:AppHeader:Header:CustomerNumber',
  pinLabel: 'Shared:AccountTray:CustomerPinLabel',
  resetPin: 'Shared:UtilityBar:AccountTray:ResetPin',
  viewPin: 'Shared:UtilityBar:AccountTray:ViewPin',
  vip: 'PC:AppHeader:Header:VipRepName',
  title: 'PC:AppHeader:Header:usermenu-title',
  internalModeTitle: 'PC:AppHeader:Header:MyAccount',
  username: 'Shared:UtilityBar:LoginForm:Username',
  proRewardPoints: 'PC:AppHeader:Header:RewardPoints',
  myHub: 'Sales:AccountTray:MyHub'
};
exports.golf = golf;